import createReducer from '../../utils/createReducer';
import {
  SETTINGS_ERROR,
  SETTINGS_SUCCESS,
} from '../../actions/settings/settingsActionConstants';

const initialState = {};

export default createReducer(
  {
    [SETTINGS_SUCCESS]: setSettings,
    [SETTINGS_ERROR]: setSettingsError,
  },
  initialState,
);

function setSettings(state, action) {
  return action.payload || initialState;
}

function setSettingsError(state, action) {
  return {
    ...state,
    ...action.errorMessage,
  };
}
